import { PAGE_URLS } from 'src/components/Router';
import { EDIT, READ } from 'src/consts';
import type { AppConfig } from 'src/modules/appConfig/types';
import type { ReduxInjections } from 'src/types';

import {
  UPDATE_ROUTE,
  UPDATE_PAGE,
  type RouterAction,
  routerReducer,
} from '../components/Router/reducer';

export const createHistoryMiddleware =
  (history: History, appConfig: AppConfig) =>
  ({ getState }: ReduxInjections) =>
  (next: (action: RouterAction) => void) =>
  (action: RouterAction) => {
    if (action.type === UPDATE_ROUTE) {
      const routerState = getState().router;
      const { mode, to } = action.payload;
      const editCount = Object.keys(routerState).filter((route) => {
        const routeState = routerState[route as keyof typeof routerState];
        return (
          typeof routeState === 'object' &&
          route !== 'latestRoute' &&
          routeState.mode === EDIT
        );
      }).length;
      const newRouterState = routerReducer(routerState, action);
      if (mode === EDIT && editCount === 0) {
        history.pushState(newRouterState, 'Edit');
      } else if (
        mode === READ &&
        editCount === 1 &&
        routerState[to].mode === EDIT
      ) {
        // Set this property again as Firefox has been intermittently misbehaving
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
        history.go(-1);
      } else if (editCount > 0) {
        history.replaceState(newRouterState, 'Edit');
      }
    }

    if (action.type === UPDATE_PAGE) {
      const {
        payload: { page },
      } = action;
      const state = getState();
      const { language } = appConfig;
      const { shareableProfileSlug } = state.router;
      const hrefPrefix = language !== 'en' ? `/${language}` : '';
      const queryString = window.location.search;
      const includeQueryString =
        queryString.includes('features=') || queryString.includes('v=branch');
      const retainedQueryString = includeQueryString ? queryString : '';

      const href =
        page === 'shareable-profile-page'
          ? `${hrefPrefix}/profile/${shareableProfileSlug}${retainedQueryString}`
          : `${hrefPrefix}${PAGE_URLS[page]}${retainedQueryString}`;

      const routerState = getState().router;
      const newRouterState = routerReducer(routerState, action);
      const pageName = page.replace(/-/g, ' ');
      history.pushState(newRouterState, pageName, href);
    }

    return next(action);
  };
